export class ServingLine {
  constructor(
    public trackingId: string = '',
    public mealCountServedFirstMeal: number = 0,
    public mealCountServedSecondMeal: number = 0,
    public mealCountServedAdultProgram: number = 0,
    public mealCountServedAdultNonProgram: number = 0,
    public mealCountIncomplete: number = 0,
    public mealCountWaste: number = 0,
    public mealCountLeftover: number = 0,
    public mealCountAdditionalRequested: number = 0,
    public mealCountNonCongregateMeal: number = 0,
    public affirmed: boolean = false,
    public servedBy: number = 0,
    public servedByFirstName: string = '',
    public servedByLastName: string = '',
    public createdDateTimeUtc: string = '',
    public modifiedDateTimeUtc: string = '',
    public mergedIntoTrackingId: string | undefined = undefined,
    public discarded: boolean = false
    ) {
  }
}
